import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-snowflake-checklist',
  templateUrl: './help-snowflake-checklist.component.html',
  styleUrls: ['./help-snowflake-checklist.component.scss']
})
export class HelpSnowflakeChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
